var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7875 10.1625C18.9948 10.3922 19.1096 10.6906 19.1096 11C19.1096 11.3094 18.9948 11.6078 18.7875 11.8375C17.475 13.25 14.4875 16 11.0001 16C7.51255 16 4.52505 13.25 3.21255 11.8375C3.00525 11.6078 2.8905 11.3094 2.8905 11C2.8905 10.6906 3.00525 10.3922 3.21255 10.1625C4.52505 8.75 7.51255 6 11.0001 6C14.4875 6 17.475 8.75 18.7875 10.1625Z",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 13.5C12.3808 13.5 13.5001 12.3807 13.5001 11C13.5001 9.61929 12.3808 8.5 11.0001 8.5C9.61935 8.5 8.50006 9.61929 8.50006 11C8.50006 12.3807 9.61935 13.5 11.0001 13.5Z",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0777b07d181787908c15c40687fd820c.svg";
export { ForwardRef as ReactComponent };